import { PurchaseOrderListPage } from "@/features/purchase-order/pages/PurchaseOrderListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/purchase-order/")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["purchase_order.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PurchaseOrderListPage,
});
